// extracted by mini-css-extract-plugin
module.exports = {"base":"MenuList_base__30g0c","menuListBody":"MenuList_menu-list-body__1JfSI","menuListItem":"MenuList_menu-list-item__2dWek","menuListDivider":"MenuList_menu-list-divider__1hxXv"};